import React from "react";
import { XCrossIcon } from "../../assets";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import {
  MASTER_SEARCH_PLACEHOLDER,
  MASTER_SEARCH_TOOL_TIP_TEXT,
} from "../../utils/constants";

interface SearchButtonModalProps {
  closeSearchModal: () => void;
}

const SearchButtonModal: React.FC<SearchButtonModalProps> = ({
  closeSearchModal,
}) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = React.useState<string | undefined>(
    undefined
  );
  const isUserOfOmniMove = useSelector(
    (state: RootState) => state.auth.isUserOfOmniMove
  );
  const agentRole = localStorage.getItem("roles") === "agent";
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };
  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    if (searchTerm !== undefined) {
      const trimmedSearchTerm = searchTerm.trim();
      if (isUserOfOmniMove && !agentRole) {
        navigate("/billed-order-history", {
          state: { searchTerm: trimmedSearchTerm },
        });
      } else {
        navigate("/all-orders", { state: { searchTerm: trimmedSearchTerm } });
      }
    }
    closeSearchModal();
  };
  return (
    <div className="modal modal--hazmatDetail modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <h4 className="modal__header--title">Search</h4>
            <button
              className="btn btn__transparent btnClose"
              onClick={closeSearchModal}
            >
              <XCrossIcon />
            </button>
          </div>
          <div className="modal__body">
            <div className="formRow">
              <div className="formCol">
                <div className="form__group form__group__viewBox ">
                  <input
                    className="form__input form__input--search form__input--sm "
                    type="text"
                    name="orderNumber"
                    placeholder={MASTER_SEARCH_PLACEHOLDER}
                    title={MASTER_SEARCH_TOOL_TIP_TEXT}
                    value={searchTerm}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(e);
                      }
                    }}
                  />
                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="btn btn__primary btn__full m_0"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default SearchButtonModal;
